var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"basic-form"},[(_vm.backupEmail)?_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t("DID")))]),_c('p',{staticClass:"input"},[_vm._v(_vm._s(_vm.backupEmail))])]):_c('VerifyCode',{on:{"submit":_vm.backup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }